// Utilitários de validação e sanitização para protótipo
export const validateEmail = (
  email: string
): { isValid: boolean; message?: string } => {
  if (!email) {
    return { isValid: false, message: "E-mail é obrigatório" };
  }

  // Regex mais robusta para validação de email
  const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

  if (!emailRegex.test(email)) {
    return { isValid: false, message: "Formato de e-mail inválido" };
  }

  if (email.length > 254) {
    return {
      isValid: false,
      message: "E-mail muito longo (máximo 254 caracteres)",
    };
  }

  return { isValid: true };
};

export const validatePassword = (
  password: string
): {
  isValid: boolean;
  message?: string;
  strength: "weak" | "medium" | "strong";
} => {
  if (!password) {
    return { isValid: false, message: "Senha é obrigatória", strength: "weak" };
  }

  if (password.length < 8) {
    return {
      isValid: false,
      message: "Senha deve ter pelo menos 8 caracteres",
      strength: "weak",
    };
  }

  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumbers = /\d/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  const criteriaMet = [
    hasUpperCase,
    hasLowerCase,
    hasNumbers,
    hasSpecialChar,
  ].filter(Boolean).length;

  if (criteriaMet < 2) {
    return {
      isValid: false,
      message:
        "Senha deve conter pelo menos: letras maiúsculas, minúsculas, números ou caracteres especiais",
      strength: "weak",
    };
  }

  if (criteriaMet === 2) {
    return { isValid: true, strength: "medium" };
  }

  return { isValid: true, strength: "strong" };
};

export const sanitizeInput = (input: string): string => {
  if (typeof input !== "string") return "";

  return input
    .trim()
    .replace(/[<>]/g, "") // Remove caracteres perigosos básicos
    .slice(0, 1000); // Limita tamanho
};

export const validateRequired = (
  value: string,
  fieldName: string
): { isValid: boolean; message?: string } => {
  const sanitized = sanitizeInput(value);

  if (!sanitized) {
    return { isValid: false, message: `${fieldName} é obrigatório` };
  }

  return { isValid: true };
};

export const validateName = (
  name: string
): { isValid: boolean; message?: string } => {
  const sanitized = sanitizeInput(name);

  if (!sanitized) {
    return { isValid: false, message: "Nome é obrigatório" };
  }

  if (sanitized.length < 2) {
    return { isValid: false, message: "Nome deve ter pelo menos 2 caracteres" };
  }

  if (sanitized.length > 100) {
    return {
      isValid: false,
      message: "Nome muito longo (máximo 100 caracteres)",
    };
  }

  // Verifica se contém apenas letras, espaços e alguns caracteres especiais comuns
  const nameRegex = /^[a-zA-ZÀ-ÿ\s\-.'']+$/;
  if (!nameRegex.test(sanitized)) {
    return { isValid: false, message: "Nome contém caracteres inválidos" };
  }

  return { isValid: true };
};

export const validateCompany = (
  company: string
): { isValid: boolean; message?: string } => {
  if (!company) return { isValid: true }; // Opcional

  const sanitized = sanitizeInput(company);

  if (sanitized.length > 200) {
    return {
      isValid: false,
      message: "Nome da empresa muito longo (máximo 200 caracteres)",
    };
  }

  return { isValid: true };
};

export const validateDescription = (
  description: string
): { isValid: boolean; message?: string } => {
  if (!description) return { isValid: true }; // Opcional

  const sanitized = sanitizeInput(description);

  if (sanitized.length > 500) {
    return {
      isValid: false,
      message: "Descrição muito longa (máximo 500 caracteres)",
    };
  }

  return { isValid: true };
};
